import { NgModule, Optional, SkipSelf } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { TaxratesEffects } from './taxrate.effects';
import { ITaxratesFeature } from './taxrate.feature.state';
import { taxratesReducer } from './taxrate.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(nameof<ITaxratesFeature>('taxratesFeature'), taxratesReducer),
    EffectsModule.forFeature([TaxratesEffects]),
  ],
})
export class TaxratesStateModule {
  public constructor(
    @Optional()
    @SkipSelf()
    parentModule: TaxratesStateModule
  ) {
    if (parentModule) {
      throw new Error('TaxratesStateModule is already loaded. Import it in the AppModule only');
    }
  }
}
